import { IUser } from '@app/shared/types/user.type';
import { IProject } from '../types/project.interface';
import { ProjectQuoteMemberType } from '../types/project-quote.interface';
import { ProjectStatusEnum } from '../enums/project-status.enum';

function normalizeQuoteMemberType(
  raw: string | null | undefined
): ProjectQuoteMemberType | null {
  const upper = String(raw ?? '').toUpperCase();
  if (upper.includes('INSTALL')) return 'INSTALLER';
  if (upper.includes('SUPPLIER')) return 'SUPPLIER';
  return null;
}

/** Resolves quote member type from the logged-in user profile fields. */
export function resolveProjectQuoteMemberType(
  user: IUser | undefined | null
): ProjectQuoteMemberType | null {
  if (!user) return null;

  const fromBusiness = normalizeQuoteMemberType(user.business?.type);
  if (fromBusiness) return fromBusiness;

  const fromUserType = normalizeQuoteMemberType(user.type);
  if (fromUserType) return fromUserType;

  return null;
}

export function resolveProjectQuoteMemberTypeFromProfileType(
  raw: string | null | undefined
): ProjectQuoteMemberType | null {
  return normalizeQuoteMemberType(raw);
}

export function isProjectQuoteEligibleStatus(
  status: string | null | undefined,
  memberType: ProjectQuoteMemberType
): boolean {
  if (!status) return false;

  if (memberType === 'INSTALLER') {
    return (
      status === ProjectStatusEnum.OPEN ||
      status === ProjectStatusEnum.SUPPLIER_SELECTED
    );
  }

  if (memberType === 'SUPPLIER') {
    return (
      status === ProjectStatusEnum.OPEN ||
      status === ProjectStatusEnum.INSTALLER_SELECTED
    );
  }

  return false;
}

export function canShowProjectQuoteButton(
  user: IUser | undefined | null,
  project: IProject | null | undefined,
  memberType: ProjectQuoteMemberType | null
): boolean {
  const isLoggedIn = (user?.roles?.length ?? 0) > 0;
  if (!isLoggedIn || !memberType || !project?._id) return false;
  return isProjectQuoteEligibleStatus(project.status, memberType);
}
